"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS_BAR_MIN_CURRENT_STEP = exports.STATUS_BAR_MAX_STEPS = exports.STATUS_BAR_MIN_STEPS = void 0;
exports.getStepStatus = getStepStatus;
exports.shouldShowLabel = shouldShowLabel;
exports.validateStepCount = validateStepCount;
exports.validateCurrentStep = validateCurrentStep;
exports.getStepPosition = getStepPosition;
exports.getProgressSize = getProgressSize;
exports.getLabelWrapperStyle = getLabelWrapperStyle;
exports.getLabelAdditionalClass = getLabelAdditionalClass;
exports.getStepStateClass = getStepStateClass;
const data_1 = require("../../data");
exports.STATUS_BAR_MIN_STEPS = data_1.statusBarConfigData.steps.min;
exports.STATUS_BAR_MAX_STEPS = data_1.statusBarConfigData.steps.max;
exports.STATUS_BAR_MIN_CURRENT_STEP = data_1.statusBarConfigData.currentStep.min;
function getStepStatus(stepIndex, currentStep) {
  if (stepIndex < currentStep) return 'completed';
  if (stepIndex === currentStep) return 'current';
  return 'pending';
}
function shouldShowLabel(stepIndex, currentStep, labelsPosition) {
  if (labelsPosition === 'all') return true;
  if (labelsPosition === 'none') return false;
  return stepIndex === currentStep;
}
function validateStepCount(totalSteps) {
  return totalSteps >= exports.STATUS_BAR_MIN_STEPS && totalSteps <= exports.STATUS_BAR_MAX_STEPS;
}
function validateCurrentStep(currentStep, totalSteps) {
  return currentStep >= exports.STATUS_BAR_MIN_CURRENT_STEP && currentStep <= totalSteps;
}
function getStepPosition(stepIndex, totalSteps, orientation) {
  const index = stepIndex - 1;
  const basePercent = index / (totalSteps - 1) * 100;
  let transform = 'translate(-50%, -50%)';
  if (orientation === 'horizontal') {
    if (index === 0) {
      transform = 'translate(calc(-50% + 8px), -50%)';
    } else if (index === totalSteps - 1) {
      transform = 'translate(calc(-50% - 8px), -50%)';
    }
    return {
      left: `${basePercent}%`,
      transform
    };
  } else {
    if (index === 0) {
      transform = 'translate(-50%, calc(-50% + 8px))';
    } else if (index === totalSteps - 1) {
      transform = 'translate(-50%, calc(-50% - 8px))';
    }
    return {
      top: `${basePercent}%`,
      transform
    };
  }
}
function getProgressSize(currentStep, totalSteps) {
  if (currentStep === 1) {
    return '16px';
  }
  const currentStepIndex = currentStep - 1;
  const stepPosition = currentStepIndex / (totalSteps - 1) * 100;
  if (currentStep === totalSteps) {
    return 'calc(100%)';
  }
  return `calc(${stepPosition}% + 8px)`;
}
function getLabelWrapperStyle(stepIndex, totalSteps, orientation) {
  const index = stepIndex - 1;
  const basePercent = index / (totalSteps - 1) * 100;
  return orientation === 'horizontal' ? {
    left: `${basePercent}%`
  } : {
    top: `${basePercent}%`
  };
}
function getLabelAdditionalClass(stepIndex, totalSteps) {
  const index = stepIndex - 1;
  if (index === 0) return 'first-label';
  if (index === totalSteps - 1) return 'last-label';
  return '';
}
function getStepStateClass(stepIndex, currentStep) {
  const status = getStepStatus(stepIndex, currentStep);
  if (status === 'pending') return 'pending';
  return status === 'current' ? 'current' : 'completed';
}
